import Http from '~fdp/core/network/http.js'

import { forEach, pick, toUpper } from 'lodash'

const WepAxiosWrapperPlugin = {
  install: function (Vue) {
    var httpInject = {}

    forEach(window.vue.config.http, (val, key) => {
      let httpConfig = pick(val, ['baseURI', 'proxy'])

      let httpObj = new Http(httpConfig)

      let axios = httpObj.axios

      httpInject[key] = httpObj

      httpInject[key].setCommonHeader(axios)
      httpInject[key].setInterceptor(axios)

      // httpInject[key].apiPath = pick(val, ['apiPath'])

      httpInject[key].axios = axios

      forEach(val.apiPath, (apiObj, apiKey) => {
        httpInject[key][apiKey] = (context, params, header) => {
          if (toUpper(apiObj.method) === 'POST') {
            return httpInject[key].post(context, apiObj.url, params, header)
          } else if (toUpper(apiObj.method) === 'GET') {
            return httpInject[key].get(context, apiObj.url, params, header)
          }
        }
        httpInject[key][apiKey + 'Url'] = apiObj.url
      })

      if (key === 'mmp') {
        httpInject.axios = axios
        httpInject.loadRes = httpObj.loadRes
        httpInject.upload = httpObj.upload
      }
    })

    window.vue.setInstance('http', httpInject)
    Vue.http = Vue.prototype.$http = httpInject
  }
}

export default WepAxiosWrapperPlugin



// WEBPACK FOOTER //
// ./src/plugins/_common/WepResource.js